import { type GoogleMapPinProps } from '../LocationListingHelpers';

export interface ClusterPinProps extends GoogleMapPinProps {
    children?: React.ReactNode;
    onClick?: () => void;
    isActive?: boolean;
}

const ClusterPin = ({ children, onClick, isActive, style }: ClusterPinProps): JSX.Element => {
    return (
        <button
            type="button"
            className={`cluster-pin ${isActive ? 'is-active' : ''}`}
            onClick={onClick}
            style={style}
        >
            {children}
        </button>
    );
};

export default ClusterPin;
